




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxy from "@/services/data-proxy.service"
    import {B2BProvajder, TipVozila} from "@/services/BackendProxies";

@Component({})
export default class B2BProvajderiEditor extends Vue {
    b2bProvajderi = [];
    @Prop() value !: string;
    @Prop() tip!: number | null;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    async created() {
        const tipovi = this.b2bProvajderi = await dataProxy.vratiB2BProvajdere(this.tip);
        tipovi.unshift(B2BProvajder.fromJS({id: '', naziv: '...'}));
        this.b2bProvajderi = tipovi.map(t => ({id: t.id, text: t.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }
}
